/* eslint-disable no-console */
<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">Karriere in der WIKA Gruppe</h1>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-two-thirds">
          <HeroSlider :slides="slides" :heightFirst="true" />
        </div>
        <div class="column is-one-third">
          <SalesContainer :config="salesContainerConfig" />
        </div>
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <h2 class="SubPage__subHeading">Stellenmarkt</h2>
      <JobsList :config="jobsListConfig" />
    </div>
    <Footer />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Footer from "../Footer/Footer";
import SalesContainer from "../SalesContainer/SalesContainer";
import PageHeader from "../PageHeader/PageHeader";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer";
import JobsList from "../JobsList/JobsList";
import HeroSlider from "../HeroSlider/HeroSlider";

export default {
  name: "JobsListPage",
  components: {
    Breadcrumbs,
    Footer,
    SalesContainer,
    PageHeader,
    CookieDisclaimer,
    JobsList,
    HeroSlider
  },
  data() {
    return {
      cookieDisclaimerConfig: {
        text:
          "Unsere Webseite verwendet Cookies. Durch die weitere Nutzung stimmen Sie der Verwendung zu.",
        link: {
          text: "Weitere Informationen",
          url: "#"
        },
        button: {
          text: "Zustimmen",
          colour: "blue"
        }
      },
      crumbs: [
        {
          title: "Startseite",
          url: "#"
        },
        {
          title: "Karriere",
          url: "#"
        },
        {
          title: "Arbeitgeber",
          url: "#"
        },
        {
          title: "Stellenmarkt",
          url: "#"
        }
      ],
      slides: [
        {
          image: "https://picsum.photos/662/257?random=1",
          newWindow: false,
          url: "#"
        },
        {
          image: "https://picsum.photos/662/257?random=2",
          newWindow: false,
          url: "#"
        },
        {
          image: "https://picsum.photos/662/257?random=3",
          newWindow: false,
          url: "#"
        }
      ],
      salesContainerConfig: {
        title: "Vertriebskontakt",
        text: "Fragen? Finden Sie Ihren Ansprechpartner im WIKA-Vertriebsteam.",
        icon: "fas fa-user-tie",
        input: {
          placeholderText: "Postleitzahl eingeben",
          submitUrl: "contact_de_at.WIKA?cnType=1&cnEntry="
        },
        buttons: [
          {
            icon: "fas fa-comments",
            text: "Jetzt chatten",
            offlineText: "Nachricht senden"
          },
          {
            icon: "fas fa-envelope",
            text: "Kontaktformular",
            linkUrl: "#"
          }
        ]
      },
      jobsListConfig: {
        listTitle: "Stellenmarkt",
        hasSearch: false,
        texts: {
          resultText: "Anzahl der gefundenen Einträge:",
          resetText: "",
          helpText: "Bitte wählen Sie eine oder mehrerer Filteroptionen.",
          pdf: "PDF",
          ebook: "Datenblatt",
          wishlist: "Merkzettel",
          validto: "Gültig bis",
          productDetail: "Details",
          productDatasheet: "Datenblatt"
        },
        resetSelectOption: "Alle",
        loadInitialData: true,
        url:
          "http://www-qa.wika.dev.intern.etecture.de/de-de/joboffers_json.json",
        withExternalData: false,
        mappingUrl:
          "http://www-qa.wika.dev.intern.etecture.de/de-de/keyword_translations_json.WIKA",
        filters: [
          {
            hasFilter: false,
            id: "targetgroup",
            key: "targetgroup",
            label: "Zielgruppe",
            sort: "asc",
            initialSelectOption: "Bitte wählen..."
          },
          {
            hasFilter: false,
            id: "country",
            key: "country",
            label: "Land",
            sort: "asc",
            initialSelectOption: "Bitte wählen..."
          },
          {
            hasFilter: false,
            id: "location",
            key: "location",
            label: "Standort",
            sort: "asc",
            initialSelectOption: "Bitte wählen..."
          },
          {
            hasFilter: false,
            id: "company",
            key: "company",
            label: "Unternehmen",
            sort: "asc",
            initialSelectOption: "Bitte wählen..."
          }
        ],
        pagination: {
          texts: {
            page: "Seite",
            of: "von"
          },
          resultsPerPage: 12,
          resultsSelect: {
            initialSelectOption: "12 Einträge pro Seite",
            selectOptions: [
              "12 Einträge pro Seite",
              "24 Einträge pro Seite",
              "Alle"
            ]
          }
        }
      }
    };
  }
};
</script>
